export const fetchAllBooks = async (userEmail: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/booklist?email=${encodeURIComponent(userEmail)}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error; // Rethrow the error to handle it in the component if needed
  }
};
